<template>
  <div>
    <template>
      <div class="">
        <AccordionHeader
          title="Product(s) Selection "
          :isAccordionOpen="isAccordionOpen"
          @onToggleView="isAccordionOpen = !isAccordionOpen"
          :isDisabled="isDisabled"
          :borderStyles="
            isAccordionOpen
              ? `border-bottom: 1px solid #232220; border-top: 1px solid #232220;`
              : 'border-top: 1px solid #232220;'
          "
        />

        <section
          v-if="isAccordionOpen"
          class="accordion-body"
          :class="{
            active: isAccordionOpen
          }"
        >
          <!-- title region -->
          <div class="title-container custom-block">
            <div class="title">
              <p><strong>Additional instructions</strong></p>
            </div>
            <div class="detail">
              <span class="detail-info">
                Add any additional instructions or recommendations to users for
                selecting products. This text will be displayed on the products
                page banner along with the default instructions.
              </span>
              <div class="detail">
                <div
                  class="customize-section special-instruction margin-bottom-2"
                >
                  <div class="input-holder">
                    <textarea
                      ref="addtionalInfoTextRef"
                      id="title-textarea"
                      rows="1"
                      @blur="handleBlur"
                      placeholder="Type instructions"
                      v-model="customSubTitle"
                    ></textarea>
                    <!-- <small class="characters-info">
                      {{
                        `${customSubtitleCharactersLeft} ${
                          customSubtitleCharactersLeft > 1 ? 'words' : 'word'
                        }  left`
                      }}
                    </small> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccordionHeader from '../AccordionHeader'
export default {
  name: 'AdditionalInstruction',
  props: ['isDisabled'],
  data() {
    return {
      customSubTitle: '',
      customSubTitleMaxCharacters: 20,
      isAccordionOpen: false
    }
  },

  components: {
    AccordionHeader
  },
  methods: {
    addCustomField() {
      this.customFields.push({ name: '', type: 'text' })
    },

    updateGroupOrder() {
      this.$store.dispatch('groupOrder/updateGroupOrder', {
        redirect: false,
        redemptionSubTitle: this.customSubTitle,
        enableCustomSubTitle: this.customSubTitle
      })
    },
    handleBlur() {
      this.updateGroupOrder()
    },
    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen
    },
    setAccordion(value) {
      this.isAccordionOpen = value
    },
    onFocusInput() {
      this.$refs.addtionalInfoTextRef.focus()
    }
  },
  computed: {
    ...mapState({
      groupOrderDetails: state => state.groupOrder.groupOrderDetails
    }),
    customSubtitleCharactersLeft() {
      if (this.customSubTitle) {
        return (
          this.customSubTitleMaxCharacters -
          this.customSubTitle.split(' ').length
        )
      } else {
        return this.customSubTitleMaxCharacters
      }
    }
  },
  watch: {
    customSubTitle(newVal) {
      if (this.customSubtitleCharactersLeft > 0) {
        this.customSubTitle = newVal
      } else {
        this.customSubTitle = newVal
          .split(' ')
          .splice(0, this.customSubTitleMaxCharacters)
          .join(' ')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.margin {
  margin-bottom: 1.5rem;
}

.custom-input {
  font-size: 0.813rem !important;
}

.accordion-body {
  height: 0px;
  opacity: 0;
  &.active {
    height: max-content;
    opacity: 1;
    margin-top: 1.7rem;
    margin-bottom: 0.3rem;
  }
}

.holder {
  text-align: left;

  h3 {
    font-size: 1.063rem;
    font-family: $inter;
    color: $main-6;
    padding-bottom: 2rem;
    padding-top: 0.5rem;

    span {
      font-weight: 400;
    }
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.header-region {
  margin: 2.5rem 0;
  border-bottom: 8px solid $main-6;
  p {
    text-align: center;
    padding-bottom: 0.6rem;
    font-size: 1.3rem;
    font-weight: 400;
  }
}

h4 {
  text-align: left;
}
.info-container {
  margin-top: 1.25rem;
  border: 1px solid #232220;
  padding-bottom: 1rem;
}

.domain-container,
.password-container,
.description-container,
.title-container {
  margin: 0rem 0;
  padding: 0 3rem 1rem 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 1rem 1rem 1rem;
  }
  .title {
    text-align: left;
  }

  .detail {
    width: 100%;
    .subheading {
      margin-bottom: 1rem;
    }
    p {
      text-align: left;
      font-size: 0.875rem;
      line-height: 24px;
    }
    .detail-info {
      font-size: 0.713rem;
      text-align: left;
      width: 100%;
      display: block;
      margin: 0.25rem 0 1rem 0;
      color: #514d43;
      font-weight: 300;
      line-height: 22px;
    }
  }
}
.aditional-info {
  margin: 2rem 0rem;
  padding: 0 2.5rem;
  display: flex;
  justify-content: space-between;

  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 100%;
    p {
      font-size: 0.813rem;
      text-align: left;
      margin-bottom: 1.25rem;
    }
  }

  .custom-fields {
    form {
      width: 100%;
      max-width: 14rem;
      text-align: left;
      margin-bottom: 2rem;

      &.padded {
        margin-bottom: 3rem;
      }

      .form-group {
        display: flex;
        align-items: flex-end;
        gap: 1rem;

        &.mt-3 {
          margin-top: 2rem;
        }
      }
    }

    .remove {
      cursor: pointer;
      display: block;
      width: 20px;
      user-select: none;
    }
  }

  .add-field {
    text-align: left;
    margin-bottom: 1.75rem;
    .button-gemnote--small {
      height: 2.375rem;
      text-transform: unset;
      padding: 0px 2rem !important;
      font-weight: normal;
      width: auto;

      &.custom-button {
        background: inherit;
        color: $onyx;
        text-transform: uppercase;
      }
    }
  }
}
.customize-section {
  display: flex;
  gap: 1.5rem;
  margin-top: 19px;
  &.password {
    grid-template-columns: 9.5rem 1fr;
    margin-top: 8px;
  }
  .radio-holder {
    width: max-content;
    height: 28px;
    display: flex;
    /* align-items: center; */

    &.password {
      margin-top: 0.5rem;
    }
  }

  &.special-instruction {
    grid-template-columns: 100% 1fr !important;
  }

  .input-holder {
    width: 64%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  textarea {
    background: inherit;
    font-family: $nunito;
    padding: 10px;
    width: 100%;
    display: block;
    /* margin-left: 0; */
    resize: none;
    border: none;
    border: 1px solid #9b9b9b;
    font-size: 0.875rem;
    min-height: 160px;

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }

    &.error {
      border-bottom: 1px solid #da5737;
    }
  }

  .input-info-holder {
    width: 100%;
    .characters-info {
      width: max-content;
    }
    .error-text {
    }
  }

  .characters-info {
    display: block;
    position: relative;
    top: 0px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 80%;
    max-width: 90%;
    text-align: right;
  }
  .password-holder {
    width: 50%;
    position: relative;

    input {
      height: 1.75rem;
      padding: 0 0;
      font-size: 0.875rem;
      background: inherit;
      font-family: $nunito;
      border: none;
      border-bottom: 1px solid #24292c;

      &.error {
        border-bottom: 1px solid #da5737;
      }
    }

    span {
      position: absolute;
      top: 9px;
      right: 0;
      font-size: 0.625rem;
      color: #676767;
      cursor: pointer;
    }
  }

  ::placeholder {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
  .error-text {
    color: #da5737;
    font-size: 10px;
  }
}
.row {
  display: flex;
  text-align: left;
  flex-wrap: wrap;
  justify-content: space-between;

  .row-holder {
    width: 33.3%;
    &.first {
      width: 25%;
    }
  }
}

.field {
  font-weight: 700;
  margin: 0.5rem 0;
  font-size: 0.813rem;
}

.button-area {
  margin-top: 3rem;
  display: flex;
  justify-content: center;

  button {
    padding: 0 2rem !important;
    width: auto;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.domain-content {
  grid-gap: 1rem;
  p {
    margin-top: 0.8rem;
    text-align: left;
  }
}
.allow-domains {
  width: 100%;
}

.title p {
  font-size: 0.913rem;
}

.detail p {
  font-size: 0.813rem !important;
}

@media (max-width: 1100px) {
  .required-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .aditional-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .field {
    flex-basis: 50%;
  }

  .row {
    .row-holder {
      width: 100%;
      &.first {
        width: 100%;
      }
    }
  }
}

@media (max-width: 800px) {
  .customize-section {
    display: block;
  }
  .custom-block {
    display: block;
  }
  .detail {
    width: 100% !important;
  }
  .domain-container {
    display: block;
  }
  .customize-section .password-holder {
    width: 100%;
  }
}
</style>
